module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'level-1': _vm.registro
    },
    attrs: {
      "id": "informacoesPonto"
    }
  }, [_c('div', {
    staticClass: "float-box-view-level-0"
  }, [_vm._m(0, false, false), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('alert', {
    attrs: {
      "msg": _vm.mensagemErro || '',
      "visible": _vm.showAlert,
      "type": "error"
    }
  })], 1), _c('div', {
    staticClass: "float-box-content"
  }, [(_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens) ? _c('listagem-registros', {
    ref: "listagemRegistros",
    attrs: {
      "registros": _vm.paginacaoRegistros.itens,
      "showMarkers": false
    },
    on: {
      "exibirRegistro": _vm.exibirRegistro
    }
  }) : _vm._e(), (!_vm.pesquisaEfetuada && (!_vm.camadasAtivas || !_vm.camadasAtivas.length)) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhuma camada ativa"
    }
  }) : _vm._e()], 1), (_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens && _vm.paginacaoRegistros.itens.length > 0) ? _c('div', {
    staticClass: "float-box-footer"
  }, [_c('paginacao', {
    ref: "paginacaoRegistros",
    attrs: {
      "total": _vm.paginacaoRegistros.totalItens,
      "page-size": _vm.paginacaoRegistros.itensPorPagina,
      "onChange": _vm.alterarPaginaRegistros,
      "options": _vm.paginationOptions
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "float-box-view-level-1"
  }, [(_vm.registro) ? _c('visualizacao-registro-camada', {
    attrs: {
      "registro": _vm.registro,
      "showReturnButton": true
    },
    on: {
      "close": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "mdi mdi-map-marker"
  }), _vm._v("Informações do ponto")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f83ce66c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inspecao/InformacoesPonto.vue
// module id = 492
// module chunks = 1